module.exports = __webpack_public_path__ + "static/media/add.a92b36ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FreelancerPortfolio/WorkExperienceCard/add.svg
// module id = 2130
// module chunks = 0